import React from 'react';
import { Shield, Lock, CheckCircle, Users, FileText } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
export function TrustSecurity() {
  const {
    t
  } = useTranslations();
  const trustItems = [{
    icon: <Users className="w-6 h-6 text-[#00E676]" data-id="element-489" />,
    title: t('trust.item1.title'),
    description: t('trust.item1.desc')
  }, {
    icon: <Shield className="w-6 h-6 text-[#00E676]" data-id="element-490" />,
    title: t('trust.item2.title'),
    description: t('trust.item2.desc')
  }, {
    icon: <CheckCircle className="w-6 h-6 text-[#00E676]" data-id="element-491" />,
    title: t('trust.item3.title'),
    description: t('trust.item3.desc')
  }, {
    icon: <Lock className="w-6 h-6 text-[#00E676]" data-id="element-492" />,
    title: t('trust.item4.title'),
    description: t('trust.item4.desc')
  }, {
    icon: <FileText className="w-6 h-6 text-[#00E676]" data-id="element-493" />,
    title: t('trust.item5.title'),
    description: t('trust.item5.desc')
  }];
  return <section className="py-20 bg-[#064E3B] text-white" data-id="element-494">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-495">
        <div className="text-center mb-16" data-id="element-496">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-497">
            {t('trust.title')}{' '}
            <span className="text-[#00E676]" data-id="element-498">{t('trust.titleHighlight')}</span>
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-499">
            {t('trust.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12" data-id="element-500">
          {trustItems.map((item, index) => <div key={index} className="text-center" data-id="element-501">
              <div className="w-14 h-14 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-502">
                {item.icon}
              </div>
              <h3 className="text-lg font-bold mb-2" data-id="element-503">{item.title}</h3>
              <p className="text-sm text-gray-300" data-id="element-504">{item.description}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-505">
          <button onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-white text-gray-900 font-bold px-8 py-4 rounded-full text-lg hover:bg-gray-100 transition-colors shadow-lg" data-id="element-506">
            {t('trust.cta')}
          </button>
        </div>
      </div>
    </section>;
}